<template>
  <section class="persons-section form-section grid-block">
    <header>
      <span>Контактные лица</span>

      <VLink
        id="create_person_btn"
        theme="link"
        @click="PersonsService.createPerson(
					localPartner.id,
					onPersonCreated
				)"
      >
        <template #icon>
          <VIcon material="add" />
        </template>
        Добавить контактное лицо
      </VLink>
    </header>

    <div class="content">
      <template v-if="persons.length === 0">
        <div class="content-no-persons">
          Контактных лиц нет
        </div>
      </template>

      <template v-else>
        <article
        v-for="person in persons"
        :key="person.id"
        @dblclick="PersonsService.editPerson(
					person.id,
					() => $emit('persons:updated')
				)"
      >
        <header>
          <div class="title">
            {{ person.name }}
          </div>

          <VContextMenuButton
            :id="'context_menu_person_' + person.id"
            v-model:visible="contextMenus[person.id]"
            theme="default"
          >
            <PersonContextMenu
              :person="person"
              :partner-id="localPartner.id"
              @person:updated="() => $emit('persons:updated')"
              @person:deleted="() => $emit('persons:updated')"
              @hide="contextMenus[person.id] = false"
            />
          </VContextMenuButton>
        </header>
        <table>
          <thead></thead>
          <tbody>
            <!-- Первая строка с почтой -->
            <tr>
              <td>E-mail</td>
              <td
                @mouseenter="$core.tooltip.show($event.currentTarget, 'Скопировать в буфер обмена')"
                @mouseleave="$core.tooltip.hide()"
                @click="handleCopyToClipboard(person.email)"
              >
                {{ person.email }}
                <VIcon material="content_copy" />
              </td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
            </tr>

            <!-- Созданные контакты (Номер телефона или скайп) -->
            <tr
              v-for="contact in person.contacts"
              :key="contact.id"
              :class="{ 'priority-contact': contact.isPreferred }"
            >
              <td>{{contact.getTypeStringRepresentation()}}</td>
              <td
                @mouseenter="$core.tooltip.show($event.currentTarget, 'Скопировать в буфер обмена')"
                @mouseleave="$core.tooltip.hide()"
                @click="handleCopyToClipboard(formatPhone(contact))"
              >
                {{ formatPhone(contact) }}
                <VIcon material="content_copy" />
              </td>
              <td>{{ contact.comment }}</td>
              <td>
                <VBadge
                  v-if="contact.isPreferred"
                  @mouseenter="$core.tooltip.show($event.currentTarget, 'Приоритетный контакт')"
                  @mouseleave="$core.tooltip.hide()"
                >
                  ПК
                </VBadge>
              </td>
            </tr>

            <!-- Последняя строка - комментарий -->
            <tr v-if="person.comment && person.comment.length > 0">
              <td>Комментарий</td>
              <td
                @mouseenter="$core.tooltip.show($event.currentTarget, 'Скопировать в буфер обмена')"
                @mouseleave="$core.tooltip.hide()"
                @click="handleCopyToClipboard(person.comment)"
              >
                {{ person.comment }}
                <VIcon material="content_copy" />
              </td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
            </tr>
          </tbody>
        </table>
      </article>
      </template>
    </div>
  </section>
</template>

<style lang="scss" src="./PersonsSection.scss" />

<script lang="ts">

import Contact 						from "@/domains/Contacts/Contact";
import Partner 						from "@/domains/Partners/Partner";
import Person 						from "@/domains/Persons/Person";
import PersonsService 		from "@/domains/Persons/PersonsService";

import PersonContextMenu  from "@/domains/Persons/PersonContextMenu/PersonContextMenu.vue";

export default defineComponent({
  name: "PersonsSection",

  components: {
    PersonContextMenu,
  },

  props: {
    localPartner: {
      type: Partner,
      default: null,
    },
  },

  data() {
    return {
      PersonsService,

      contextMenus: {} as Record<string | number, boolean>,
    };
  },

  computed: {
    persons(): Person[] {
      return this.localPartner.persons ?? [];
    },
  },

  methods: {
    /** при создании нового контактного лица,
     * мы сразу переоткрываем его в режиме редактирования,
     * чтобы пользователь мог добавить контакты. если пожелает
     *
     * поэтому и делаем кастомный onPersonCreated, а не используем из сервиса
     * */

    onPersonCreated(newPerson: Person) {
      this.$emit('persons:updated');
      PersonsService.editPerson(
        newPerson.id,
        () => this.$emit('persons:updated')
      );
    },

    handleCopyToClipboard(entity: any) {
      this.$core.utils.copyToClipboard(entity);
      this.$core.showNotification.success(`${entity} скопирован в буфер обмена`);
    },

    formatPhone(contact: Contact) {
      if (contact?.type?.id === 'phone') {
        return this.$core.utils.number.formatPhoneNumber(contact.value);
      }

      return contact.value;
    },
  },
});
</script>
